<div [class.dark-theme]="formDarkTheme.value">
  <mat-drawer-container class="fullpage">
    <mat-drawer #drawer class="sidenav" mode="over">
      <mat-list>
        <mat-list-item>
          <strong>NijiMado</strong>
        </mat-list-item>
      </mat-list>
      <mat-nav-list>
        <a
          mat-list-item
          [routerLink]="['/home']"
          routerLinkActive="router-link-active"
          >Play</a
          >
          <a
            mat-list-item
            [routerLink]="['/about']"
            routerLinkActive="router-link-active"
            >About</a
            >
          </mat-nav-list>
          <mat-list>
            <mat-list-item>
              <mat-slide-toggle [formControl]="formDarkTheme"
                >Dark Mode</mat-slide-toggle
                >
              </mat-list-item>
              <mat-list-item>
                <mat-slide-toggle [formControl]="formEnglish"
                  >English</mat-slide-toggle
                  >
                </mat-list-item>
              </mat-list>
              <mat-divider></mat-divider>
              <mat-nav-list>
                <div mat-subheader>Stats</div>
                <a
                  mat-list-item
                  [routerLink]="['/stats/hourly']"
                  routerLinkActive="router-link-active"
                  >毎時 - Hourly</a
                  >
                </mat-nav-list>
                <mat-divider></mat-divider>
                @if (dev()) {
                  <mat-action-list>
                    <div mat-subheader>開発版 - Dev</div>
                    @if (providerIcon(); as icon) {
                      <a
                        mat-list-item
                        style="text-decoration: none"
                        [routerLink]="['/add-channel']"
                        routerLinkActive="router-link-active"
                        >
                        {{ 'チャンネル追加' | translate }}
                      </a>
                      <button mat-list-item (click)="logout()">
                        <fa-icon [icon]="icon"></fa-icon>
                        <span style="width: 1rem"></span>
                        {{ 'ログアウト' | translate }}
                      </button>
                    } @else {
                      <button mat-list-item (click)="login()">
                        {{ 'ログイン' | translate }}
                      </button>
                    }
                  </mat-action-list>
                }
              </mat-drawer>

              <div class="toggle-button-wrapper">
                <button
                  mat-flat-button
                  aria-label="toggle side navigation"
                  class="toggle-button"
                  (click)="drawer.toggle()"
                  >
                  @if (drawer.opened) {
                    <mat-icon>arrow_left</mat-icon>
                  } @else {
                    <mat-icon>arrow_right</mat-icon>
                  }
                </button>
              </div>
              <router-outlet></router-outlet>
            </mat-drawer-container>
          </div>
